export default {"src":"/_next/static/media/BYND.9cbee87b.svg","height":18,"width":18};